module.exports = __webpack_public_path__ + "img/icon-account-password-green@3x.bd2dc02c.png";